import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { TextInputControl } from 'src/app/form-controls/text-input/text-input.control';
import { SheetItemService } from 'src/app/services/sheet-item.service';
import { ItemTypeMetadata, SheetItemFormBase } from 'src/app/services/sheets-renderer.service';
import { Row } from 'src/app/types/aggregate-graph.types';
import { TransferInstruction } from 'src/app/types/sheet-instruction.types';
import { InstructionsFormComponent } from '../../instructions-form/instructions-form.component';

interface TransferInstructionFormGroup {
	receivingService: FormControl<string | null>;
}

@Component({
    selector: 'app-transfer-item-form',
    templateUrl: './transfer-item-form.component.html',
    styleUrl: './transfer-item-form.component.scss',
    imports: [ReactiveFormsModule, InstructionsFormComponent, TextInputControl],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TransferItemFormComponent implements SheetItemFormBase, OnInit {

	@Input() instructionTypeName!: string;
	@Input() item!: Row | null;
	@Input() minDate!: string;
	@Input() maxDate!: string;
	@Input() instructionsFormArray!: FormArray;
	@Input() itemConfig!: ItemTypeMetadata;


	constructor(private sheetItemService: SheetItemService, private formBuilder: FormBuilder) {
	}

	ngOnInit() {
		this.sheetItemService.getInstructions(this.item, this.instructionTypeName, this.itemConfig.scheduleConfig.defaultScheduleType, this.itemConfig.scheduleConfig.defaultRepeatingScheduleFrequency).forEach(instruction => {
			const group: FormGroup<TransferInstructionFormGroup> = this.sheetItemService.buildExistingInstructionGroup(this.instructionTypeName, instruction);
			const transferInstruction = instruction as TransferInstruction;
			group.addControl('receivingService', this.formBuilder.control(transferInstruction.receivingService ?? null, Validators.required));
			this.instructionsFormArray.push(group);
		});
	}

	addInstruction() {
		const group: FormGroup<TransferInstructionFormGroup> = this.sheetItemService.getNewInstructionGroup(this.instructionTypeName, this.itemConfig.scheduleConfig.defaultScheduleType, this.itemConfig.scheduleConfig.defaultRepeatingScheduleFrequency);
		group.addControl('receivingService', this.formBuilder.control(null, Validators.required));
		this.instructionsFormArray.push(group);
	}
}